import { PackageHistory } from 'src/app/core/models/package-tracking.model';

export const PACKAGE_HISTORY = {
  DOWNLOAD: $localize`Download`,
  FOLLOW_UP: $localize`Driver Follow Up`,
  RS_LABEL: $localize`RS Label`,
  PACKAGE_INQUIRY: $localize`Package Inquiry`,
};

export const EVENT_TYPE_CONSTS = {
  //DATA MOVEMENT
  ORIGINAL_ADDRESS: $localize`Original Address` + ':',
  PREFERRED_ADDRESS: $localize`Preferred Address:`,
  INSERT_TIME: $localize`Insert Time` + ':',
  UPDATE_TIME: $localize`Update Time` + ':',
  VALID: $localize`Valid:`,
  PDI_ACTIVE: $localize`PDI Active` + ':',
  LAT_LONG: $localize`Lat/Long:`,
  ADL_ELIGIBLE: $localize`ADL Eligible` + ':',
  ////////////
  //Scheduled Delivery Date
  SCHEDULED_DELIVERY_DATE: $localize`Scheduled Delivery Date:`,
  ////////////
  //Scan to Car
  ROUTE_ID: $localize`Route Id` + ':',
  COMMIT_TIME: $localize`Commit Time` + ':',
  UPDATED_COMMIT_TIME: $localize`Updated Commit Time:`,
  EVENT_CREATED: $localize`Event Created:`,
  EVENT_STORED: $localize`Event Stored:`,
  INTERCEPT: $localize`Intercept:`,
  DUPLICATE: $localize`Duplicate` + ':',
  REMOVAL: $localize`Removal:`,
  DFU: $localize`DFU`,
  RS_LABEL: $localize`RS Label` + ':',

  ////////////
  //Redeliver
  FUTURE_DATE: $localize`Future Date` + ':',
  ////////////
  //Delivery Status
  DELIVERY_ADDRESS: $localize`Delivery Address` + ':',
  STOP_TIME: $localize`Stop Time` + ':',
  DELIVERY_STATE: $localize`Delivery State:`,
  REASON: $localize`Reason` + ':',
  ////////////
  //Exception Processing
  NEW_ADDRESS: $localize`New Address:`,
  STATUS: $localize`Status` + ':',
  RESOLUTION: $localize`Resolution` + ':',
  ////////////
  //Pickup Scan
  PICKUP_ADDRESS: $localize`Pickup Address:`,
  ////////////
  //Handover Scan
  REFERENCE: $localize`Reference ID:`,
  // ADDRESS CORRECTION
  CORRECTED_ADDRESS: $localize`Corrected Address`,
  PIN_DROP: $localize`Pin Drop`,

  ////////////
};

export enum EVENT_TYPES {
  DATA_MOVEMENT = 'PLD Data Movement',
  SCHEDULED_DELIVERY_DATE = 'Scheduled Delivery Date',
  SCAN_TO_CAR = 'Scan to Car',
  ADDRESS_CORRECTION = 'Address Correction',
  REDELIVER = 'REDELTO ADD',
  DELIVERY_STATUS = 'Delivery Status',
  PICKUP_SCAN = 'Pickup Scan',
  EXCEPTION_PROCESSING = 'Exception Processing',
  BUILDING_SCAN = 'Building Scan',
  HANDOVER_SCAN = 'Handover Scan',
  FRAUD_HOLD = 'FRAUD HOLD',
  RTS_PENDING = 'RTS PENDING',
  RET_LOC_PEND = 'RET LOC PEND',
}

export enum WARNING_TYPES {
  //UNKNOWN TYPES FOR WARNING VALUES FROM BE
  RS_LABEL = 'RSLABEL',
  DRIVER_FOLLOWUP = 'DRIVER_FOLLOWUP',
  ////////////////////////////////////////////////////////////////////////////////////
}

export const COMMON_FIELDS = [
  $localize`Source`,
  $localize`Event Type`,
  $localize`User Id`,
];

export const EXCEL_FILE_NAME = 'package-history';

export const MOCK_PACKAGE_HISTORY_EVENTS: PackageHistory = {
  manifestHistory: [
    {
      dateTimestamp: '2023-12-28 21:44:21',
      eventDescription: 'Scan to Car',
      source: 'CAS',
      userID: 'PAVAN',
      routeID: '001',
      dfu: 'N',
      rsLabel: 'N',
      commitTime: 'N/A',
      updatedCommitTime: 'N/A',
      eventCreated: '2023-12-28 20:21:20',
      eventStored: '2023-12-28 21:44:21',
      intercept: 'N',
      duplicate: 'N',
      removal: 'N',
    },
    {
      dateTimestamp: '2023-12-28 21:43:30',
      eventDescription: 'Scan to Car',
      source: 'CAS',
      userID: 'PAVAN',
      routeID: '001',
      dfu: 'N',
      rsLabel: 'N',
      commitTime: 'N/A',
      updatedCommitTime: 'N/A',
      eventCreated: '2023-12-28 20:19:13',
      eventStored: '2023-12-28 21:43:30',
      intercept: 'N',
      duplicate: 'N',
      removal: 'N',
    },
  ],
  addressValidationHistory: [
    {
      dateTimestamp: '2023-12-28 20:43:18',
      eventDescription: 'Address Correction',
      source: 'AMS',
      userID: 'PAVAN',
      originalAddress: 'null nullnullnullnull',
      correctedAddress: 'TESTnullnullnull64807',
      valid: 'Y',
      latLong: 'null-null',
      eventCreated: '2023-12-28 20:43:18',
      pinDrop: 'N',
      correctedValid: 'Y',
      correctedLatLong: '49.898409000000001-8.8387290000000007',
    },
  ],
  intercept: [],
  delivery: [],
  pickup: [],
  exception: [],
  buildingScan: [],
  handoverScan: [],
  packageForecast: [],
};
